/* Simple Sip — ss.js = the FROZEN mock v12 script minus the fake forms (see port/build_static.py). Vanilla, idempotent, re-inits on shopify:section:load. */
(function(){
  document.documentElement.classList.add('js');
  var $=function(s,r){return (r||document).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(){
    var els=$$('.ss-r').filter(function(e){return !e.dataset.ssR});
    if(!els.length) return;
    if(reduce||!('IntersectionObserver' in window)){els.forEach(function(e){e.dataset.ssR='1'});return}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting||x.boundingClientRect.top<0){x.target.classList.add('is-in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.05});
    els.forEach(function(e){e.dataset.ssR='1';io.observe(e)});
    var t;addEventListener('scroll',function(){cancelAnimationFrame(t);t=requestAnimationFrame(function(){els.forEach(function(e){if(!e.classList.contains('is-in')&&e.getBoundingClientRect().top<innerHeight)e.classList.add('is-in')})})},{passive:true});
  }

  function drawer(){
    $$('[data-ss-open]').forEach(function(b){
      if(b.dataset.ssInit) return; b.dataset.ssInit='1';
      var d=$(b.getAttribute('data-ss-open')); if(!d) return;
      function close(){d.classList.remove('is-open');d.setAttribute('aria-hidden','true');document.documentElement.style.overflow=''}
      b.addEventListener('click',function(){d.classList.add('is-open');d.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';var f=$('a,button',d.querySelector('nav')||d);f&&f.focus()});
      $$('[data-ss-close]',d).forEach(function(c){c.addEventListener('click',close)});
      document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
    });
  }

  /* why: hovering a feature row lights the matching part of the line drawing (and the other way round) */
  function why(){
    $$('.ss-why').forEach(function(sec){
      if(sec.dataset.ssInit) return; sec.dataset.ssInit='1';
      var items=$$('[data-part]',sec);
      function set(part,on){items.forEach(function(e){if(e.dataset.part===part)e.classList.toggle('is-hot',on)})}
      items.forEach(function(e){
        e.addEventListener('mouseenter',function(){set(e.dataset.part,true)});
        e.addEventListener('mouseleave',function(){set(e.dataset.part,false)});
        if(e.tagName==='LI'||e.tagName==='BUTTON'){e.setAttribute('tabindex','0');e.addEventListener('focus',function(){set(e.dataset.part,true)});e.addEventListener('blur',function(){set(e.dataset.part,false)});
          e.addEventListener('click',function(){var on=!e.classList.contains('is-hot');items.forEach(function(x){x.classList.remove('is-hot')});set(e.dataset.part,on)})}
      });
    });
  }

  function tracks(){
    $$('[data-ss-track]').forEach(function(tr){
      if(tr.dataset.ssTrack2) return; tr.dataset.ssTrack2='1';
      var key=tr.dataset.ssTrack, nav=$('[data-ss-nav="'+key+'"]'), items=$$(':scope > *',tr), n=items.length;
      function idx(){var x=tr.scrollLeft,best=0,bd=1e9;items.forEach(function(it,i){var d=Math.abs(it.offsetLeft-tr.offsetLeft-x);if(d<bd){bd=d;best=i}});return best}
      function go(i){i=Math.max(0,Math.min(n-1,i));var it=items[i];tr.scrollTo({left:it.offsetLeft-tr.offsetLeft,behavior:reduce?'auto':'smooth'})}
      function paint(){var i=idx();if(nav){var num=$('.ss-nav__n',nav);num&&(num.textContent=(i+1)+' / '+n);var pv=$('[data-dir="-1"]',nav),nx=$('[data-dir="1"]',nav);pv&&(pv.disabled=i<=0);nx&&(nx.disabled=tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-2)}}
      if(nav){$$('button[data-dir]',nav).forEach(function(b){b.addEventListener('click',function(){go(idx()+ +b.dataset.dir)})})}
      var raf;tr.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(paint)},{passive:true});
      addEventListener('resize',paint);paint();
    });
  }


  function footerAcc(){
    var cols=$$('.ss-footer__col details'); if(!cols.length) return;
    function set(){var open=matchMedia('(min-width: 768px)').matches;cols.forEach(function(d){if(open)d.open=true;else if(!d.dataset.ssTouched)d.open=false})}
    cols.forEach(function(d){if(!d.dataset.ssInit){d.dataset.ssInit='1';d.addEventListener('toggle',function(){if(!matchMedia('(min-width: 768px)').matches)d.dataset.ssTouched='1'})}});
    set();addEventListener('resize',set);
  }

  function init(){drawer();why();tracks();footerAcc();reveal()}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  document.addEventListener('shopify:section:load',init);
})();
